import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { history } from "../../Helpers/history";
import { fetchWrapper } from "../../Helpers/fetch-wrapper";
import { PersonsService } from "../../services/personsService";

const name = "auth";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

function createInitialState() {
  return {
    user: null,
    hydrated: false,
    isHydrating: false,
    error: null,
  };
}

function createReducers() {
  return {
    acceptedTerms,
    setUserOrg,
    resetUser,
  };

  function acceptedTerms(state) {
    if (state.user) {
      state.user.terms_accepted_at = new Date().toString();
    }
  }


  function setUserOrg(state, action) {
    if (!state.user) return;

    state.user.organisation = action.payload;
    state.user.organisation_id = action.payload?.id ?? state.user.organisation_id;
  }

  function resetUser(state) {
    state.user = null;
    state.hydrated = true;
    state.isHydrating = false;
  }
}

function createExtraActions() {
  return {
    hydrateCurrentUser: hydrateCurrentUser(),
    login: login(),
    logout: logout(),
  };

  function hydrateCurrentUser() {
    return createAsyncThunk(
      `${name}/hydrateCurrentUser`,
      async (_, { rejectWithValue }) => {
        try {
          return await PersonsService.getCurrent();
        } catch (error) {
          return rejectWithValue(error);
        }
      }
    );
  }

  function login() {
    return createAsyncThunk(
      `${name}/login`,
      async ({ email, password }, { rejectWithValue }) => {
        try {
          await fetchWrapper.post(
            `${process.env.REACT_APP_API_ENDPOINT}/login`,
            {
              email,
              password,
            }
          );

          return await PersonsService.getCurrent();
        } catch (error) {
          return rejectWithValue(error);
        }
      }
    );
  }

  function logout() {
    return createAsyncThunk(
      `${name}/logout`,
      async () =>
        await fetchWrapper.post(
          `${process.env.REACT_APP_API_ENDPOINT}/logout/`
        )
    );
  }
}

function createExtraReducers() {
  return (builder) => {
    builder
      .addCase(extraActions.hydrateCurrentUser.pending, (state) => {
        state.isHydrating = true;
        state.error = null;
      })
      .addCase(extraActions.hydrateCurrentUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.hydrated = true;
        state.isHydrating = false;
        state.error = null;
      })
      .addCase(extraActions.hydrateCurrentUser.rejected, (state) => {
        state.user = null;
        state.hydrated = true;
        state.isHydrating = false;
      })
      .addCase(extraActions.login.pending, (state) => {
        state.error = null;
      })
      .addCase(extraActions.login.fulfilled, (state, action) => {
        if (action.payload.success === false) {
          state.error = action.payload;
          return;
        }

        state.user = action.payload;
        state.hydrated = true;
        state.isHydrating = false;

        const { from } = history.location.state || { from: { pathname: "/" } };
        history.navigate(from);
      })
      .addCase(extraActions.login.rejected, (state, action) => {
        state.error = action.payload;
        state.hydrated = true;
        state.isHydrating = false;
      })
      .addCase(extraActions.logout.pending, (state) => {
        state.error = null;
      })
      .addCase(extraActions.logout.fulfilled, (state, action) => {
        if (action.payload?.message === "Unauthorised") {
          state.error = "Unauthorised";
          return;
        }
        state.user = null;
        state.hydrated = true;
        state.isHydrating = false;
        history.navigate("/login");
      })
      .addCase(extraActions.logout.rejected, (state, action) => {
        state.user = null;
        state.hydrated = true;
        state.isHydrating = false;
        state.error = action.error;
        history.navigate("/login");
      });
  };
}

